<template>
  <div>
    <b-row>
      <H2>Call History</H2>
    </b-row>
    <b-row>
      <b-link
          class="b-link-menu"
          @click="handleGoBack">
        All ({{userDataLogs.length}})
      </b-link> |
      <b-link
          class="b-link-menu"
          @click="handleGoToDocsViewClick">
        Docs ({{userDataLogDocsAll.length}})
      </b-link> |
      <b-link
          class="b-link-menu"
          @click="handleGoToDocsViewClick">
        Audio ({{userDataLogAudiosAll.length}})
      </b-link> |
      <b-link
          class="b-link-menu"
          @click="handleGoBack">
        Incoming ({{userDataLogs.length}})
      </b-link> |
      <b-link
          class="b-link-menu"
          @click="handleGoBack">
        Outgoing ({{userDataLogsOutgoing.length}})
      </b-link>
    </b-row>
    <hr />
    <b-carousel
        :ref="slideId"
        :id="slideId"
        v-model="slide"
        :interval="settingsInterval"
        :controls="controls"
        :indicators="indicators"
        background="#FFFFFF"
        @sliding-start="handleSlidingStart"
        @sliding-end="handleSlidingEnd"
        :no-touch="noTouch"
        :fade="fadeTransition"
    >
      <b-carousel-slide id="TableView">
        <template #img>
          <log-table-view
              :resource="resource"
              :items="userDataLogs"
              :log-docs-all="userDataLogDocsAll"
              @log-row-clicked="handleLogTableRowClick"
              @go-to-docs-view="handleGoToDocsViewClick"
          />
        </template>
      </b-carousel-slide>

      <b-carousel-slide id="DetailView">
        <template #img>
          <log-detail-view
              v-if="selectedLog"
              :resource="resource"
              :settings="settings"
              :user-data="userData"
              :log="selectedLog"
              @log-row-clicked="handleLogTableRowClick"
          />
        </template>
      </b-carousel-slide>

      <b-carousel-slide id="DocsView">
        <template #img>
          <log-docs-view
              :resource="resource"
              :items="userDataLogs"
              :log-docs-all="userDataLogDocsAll"
              @log-row-clicked="handleLogTableRowClick"
              @go-to-docs-view="handleGoToDocsViewClick"
          />
        </template>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>
<script>
import PhotoCard from "../photoCard";
import LogTableView from "./logTableView";
import LogDocsView from "./logDocsView";
import LogDetailView from "./logDetailsView";
import DefaultLogs from "../../../assets/json/defaultLogs.json";
import moment from "moment";
export default {
  name: "CallLog_SlideView",
  components: {
    PhotoCard,
    LogTableView,
    LogDetailView,
    LogDocsView
  },
  props: {
    resource: {
      type: Object,
      default: () => {}
    },
    settings: {
      type: Object,
      default: () => {}
    },
    userData: {
      type: Object,
      default: () => {}
    }
  },
  created() {},
  mounted() {},
  computed: {
    /* SETTINGS */
    /* SETTINGS */
    settingsInterval() {
      return 0;
      return this.settings && this.settings.user && this.settings.user.interval
          ? this.settings.user.interval * 1000
          : 4;
    },
    /* DATA */
    userDataLogs() {
      return this.userData && this.userData.logs
          ? this.userData.logs
          : [];
    },
    userDataLogsOutgoing() {
      return this.userDataLogs.filter((x=>{return x.isOutgoing === true}));
    },
    userDataLogsIncoming() {
      return this.userDataLogs.filter((x=>{return x.isOutgoing === false}));
    },
    userDataLogDocsAll() {
      let docs = [];
      if (this.userData && this.userData.logs && Array.isArray(this.userData.logs)){
        this.userData.logs.forEach((aLog) =>{
          if (aLog.docs && Array.isArray(aLog.docs) &&  aLog.docs.length >0) {
            docs = [... docs, ...aLog.docs];
          }
        })
      }
      return docs;
    },
    userDataLogAudiosAll() {
      let audios = [];
      if (this.userData && this.userData.logs && Array.isArray(this.userData.logs)){
        this.userData.logs.forEach((aLog) =>{
          if (aLog.audio &&  aLog.audio >0) {
            audios = [... audios, ...aLog.audio];
          }
        })
      }
      return audios;
    }
  },
  methods: {
    handleGoBack(){
      this.$refs[this.slideId].setSlide(0);
    },
    handleLogTableRowClick(logObj){
      //Go to Detail View
      this.selectedLog = logObj;
      this.$refs[this.slideId].setSlide(1);
    },
    handleGoToDocsViewClick(){
      this.$refs[this.slideId].setSlide(2);
    },
    handleSlidingStart(numberSlidingTo) {},
    handleSlidingEnd(numberSlidTo) {},
  },
  data() {
    return {
      DefaultLogs,
      selectedLog: {},
      assetsURLHome: "", //assets/apps/calllog/',
      /* SLIDE INFO*/
      slideId: "audioSlides",
      controls: false,
      indicators: false,
      noTouch: false,
      fadeTransition: false,
      slide: 0,
      sliding: null,
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.b-link-menu {
  margin-left: 5px;
  padding-right: 5px;
}

</style>
